import * as tslib_1 from "tslib";
import { View } from './../view';
var NodeView = (function (_super) {
    tslib_1.__extends(NodeView, _super);
    function NodeView(node, id) {
        var _this = _super.call(this, id) || this;
        _this.node = node;
        _this.node.view = _this;
        return _this;
    }
    NodeView.prototype.text = function (value) {
        if (value === undefined) {
            return this.node.textContent || '';
        }
        else {
            this.node.textContent = value;
            return this;
        }
    };
    NodeView.prototype.attachApp = function () {
        var node = this.node;
        var parentNode;
        while (parentNode = node.parentNode, parentNode) {
            if (parentNode.view instanceof View.AppView) {
                var parentView = parentNode.view;
                parentView.appendChildView(node.view);
                break;
            }
            else if (parentNode instanceof HTMLBodyElement) {
                var parentView = View.AppView.create(parentNode);
                parentView.appendChildView(node.view);
                break;
            }
            else if (!(parentNode instanceof HTMLHeadElement) && !(parentNode instanceof HTMLHtmlElement)) {
                var parentView = NodeView.create(parentNode);
                parentView.appendChildView(node.view);
                node = parentNode;
            }
            else {
                break;
            }
        }
    };
    NodeView.create = function (node) {
        if (node instanceof NodeView) {
            return node;
        }
        else if (typeof node === 'string') {
            return new View.ElemView(document.createElement(node));
        }
        else if (node.view) {
            return node.view;
        }
        else if (node instanceof HTMLElement) {
            return new View.HtmlView(node);
        }
        else if (node instanceof SVGElement) {
            return new View.SvgView(node);
        }
        else if (node instanceof Element) {
            return new View.ElemView(node);
        }
        else if (node instanceof Text) {
            return new View.TextView(node);
        }
        else {
            return new NodeView(node);
        }
    };
    return NodeView;
}(View));
export { NodeView };
View.NodeView = NodeView;
//# sourceMappingURL=data:application/json;base64,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